import type { FaireProductEntity } from "../../entity_types/product";

export const p_6bvv5kxmaf: FaireProductEntity = {
  token: "p_6bvv5kxmaf",
  type: "product",
  name: "Dirty Martini Olive Cotton Tea Towel",
  brandToken: "b_89sio4o216",
  brandName: "One & Only Paper",
  imageUrl:
    "https://cdn.faire.com/fastly/3f7b5a4551296e6c9961f6af0c547ecf9eb8e21bafba491064ac1b49ee50ed10.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/33de2976fef93993bcd7fe83bdf0b83eeccae54583ff13deee4abd1c0ecc12cc.jpeg",
    "https://cdn.faire.com/fastly/106cc5400f2845ff9f116fc8ee2db462b98a9c2e4df4ed14f5b855b3e6d7b8ea.jpeg",
    "https://cdn.faire.com/fastly/ab5dc7823412209f1c45c2df9c91f45e1473d3720cf6d372f529fef1cf11f482.jpeg",
    "https://cdn.faire.com/fastly/fbf656753a077a927d66674f3a895818c60c4204845be3ed349c1b0a96594b0c.jpeg",
  ],
  priceDollars: 11.5,
  description:
    "Add a splash of personality to your kitchen! Featuring a cheeky all-over olive print with some pimento red, it’s the perfect blend of function and fun. Whether you're drying dishes, dressing up your bar cart, or laying out a snack spread, this towel brings a hit of happy hour wherever it lands.\n\nWhite 18.8 x 29.9 inch tea towel\nScreen printed for crisp, vibrant detail\nMade from 100% half panama unbleached cotton (233 gsm) for a thicker, more luxe feel\nHemmed on all sides with a hanging loop for easy storage\nMade in the UK\nCARE INSTRUCTIONS:Wash in cold water only. Do not tumble dry.\n\nPerfect for gifting, hosting, or just treating yourself to a little kitchen upgrade!",
  tags: [],
  msrpDollars: 23,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-09-01T22:12:29.541Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
